import {
  changeResultsFilters,
  FlightTimeSortTypes,
  selectResultsFilters,
} from "../searchFlightsSlice";
import React, { useCallback, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons/faAngleDown";
import { useOnClickOutside } from "../../../hooks/useOnClickOutside";

function SortDropdown() {
  const dropdownRef = useRef(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState<boolean>(false);
  const [highlightedIndex, setHighlightedIndex] = useState<number>(0);
  useOnClickOutside(
    dropdownRef,
    useCallback(() => setActive(false), [setActive])
  );
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { sortBy } = useAppSelector(selectResultsFilters);

  const options = [
    FlightTimeSortTypes.Departure,
    FlightTimeSortTypes.Arrival,
    FlightTimeSortTypes.Duration,
  ];

  const onClick = () => {
    setActive(!active);
    if (!active) {
      setHighlightedIndex(options.indexOf(sortBy));
      setTimeout(() => menuRef.current?.focus(), 0);
    }
  };

  const onSelect = (value) => {
    dispatch(changeResultsFilters({ sortBy: value }));
    setActive(!active);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) => (prev + 1) % options.length);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex(
        (prev) => (prev - 1 + options.length) % options.length
      );
    } else if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onSelect(options[highlightedIndex]);
    } else if (e.key === "Escape") {
      setActive(false);
    }
  };

  return (
    <div className={`dropdown ${active ? " is-active" : ""}`}>
      <div className="dropdown-trigger">
        <button
          className="button"
          aria-haspopup="true"
          aria-controls="dropdown-menu"
          onClick={onClick}
        >
          <span>{t("HEADER_SORT")}</span>
          <span className="icon">
            <FontAwesomeIcon icon={faAngleDown} aria-hidden="true" />
          </span>
        </button>
      </div>
      <div
        ref={menuRef}
        className="dropdown-menu"
        id="dropdown-menu"
        role="menu"
        tabIndex={-1}
        onKeyDown={handleKeyDown}
      >
        <ul className="dropdown-content">
          <li>
            <a
              onMouseDown={() => onSelect(FlightTimeSortTypes.Departure)}
              onMouseEnter={() => setHighlightedIndex(0)}
              href="#"
              tabIndex={-1}
              className={`dropdown-item${
                sortBy === FlightTimeSortTypes.Departure ? " is-active" : ""
              }${highlightedIndex === 0 && active ? " is-highlighted" : ""}`}
            >
              {t("RADIO_SORTBY_DEPARTURE_TIME")}
            </a>
          </li>

          <li>
            <a
              onMouseDown={() => onSelect(FlightTimeSortTypes.Arrival)}
              onMouseEnter={() => setHighlightedIndex(1)}
              href="#"
              tabIndex={-1}
              className={`dropdown-item${
                sortBy === FlightTimeSortTypes.Arrival ? " is-active" : ""
              }${highlightedIndex === 1 && active ? " is-highlighted" : ""}`}
            >
              {t("RADIO_SORTBY_ARRIVAL_TIME")}
            </a>
          </li>
          <li>
            <a
              onMouseDown={() => onSelect(FlightTimeSortTypes.Duration)}
              onMouseEnter={() => setHighlightedIndex(2)}
              href="#"
              tabIndex={-1}
              className={`dropdown-item${
                sortBy === FlightTimeSortTypes.Duration ? " is-active" : ""
              }${highlightedIndex === 2 && active ? " is-highlighted" : ""}`}
            >
              {t("RADIO_SORTBY_DURATION")}
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default SortDropdown;
